export const associationFeesStyles = {
  gridTemplateColumns: `repeat(4, 1fr)`,
  margin: '24px 0 24px',
};

export const propertyStyles = {
  paddingBottom: '24px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const extendableRadioStyles = {
  display: 'block',
};
